package com.hyperether.goodjob.models

enum class JobStatus {
    draft,
    open,
    in_progress,
    on_hold,
    pendingApproval,
    cancelled,
    completed,
}